import { Route } from '@angular/router';
import { authGuard, developmentGuard } from '@dental-ui/auth';
import { ClinicShellComponent } from '@dental-ui/clinic-shell';


export const appRoutes: Route[] = [
  {
    path: '',
    component: ClinicShellComponent,
    canActivate: [authGuard, developmentGuard],
    children: [
      {
        path: '',
        redirectTo: 'main',
        pathMatch: 'full',
      },
      {
        path: 'main',
        loadComponent: () => import('@dental-ui/main').then((m) => m.MainComponent),
      },
      {
        path: 'patient',
        loadComponent: () => import('@dental-ui/patient').then((m) => m.PatientListComponent),
      },
      {
        path: 'patient-create',
        loadComponent: () => import('@dental-ui/patient').then((m) => m.PatientCreateComponent),
      },
      {
        path: 'patient-detail/:id',
        loadComponent: () => import('@dental-ui/patient').then((m) => m.PatientDetailComponent),
      },
      {
        path: 'clinical-service',
        loadComponent: () => import('@dental-ui/clinical-service').then((m) => m.ClinicalServiceListComponent),
      },
      {
        path: 'appointment',
        loadComponent: () => import('@dental-ui/calendar').then((m) => m.CalendarViewComponent),
      },
      {
        path: 'clinical-service-price',
        loadComponent: () => import('@dental-ui/clinical-service-price').then((m) => m.ClinicalServicePriceListComponent),
      },
      {
        path: 'treatment-planning',
        loadComponent: () => import('@dental-ui/threatment-planing').then((m) => m.TreatmentPlanningCreateComponent),
      },
      {
        path: 'treatment-planning-create',
        loadComponent: () => import('@dental-ui/threatment-planing').then((m) => m.TreatmentPlanningCreateComponent),
      },
      {
        path: 'treatments',
        loadComponent: () => import('@dental-ui/patient-clinical-service').then((m) => m.PatientClinicalServiceMainListComponent),
      },
      {
        path: 'workorders',
        loadComponent: () => import('@dental-ui/workorder').then((m) => m.WorkorderListComponent),
      },
      {
        path: 'workorder-detail/:id',
        loadComponent: () => import('@dental-ui/workorder').then((m) => m.WorkorderDetailComponent),
      },
      {
        path: 'payments',
        loadComponent: () => import('@dental-ui/payments').then((m) => m.PaymentsComponent),
      },
      {
        path: 'laboratories',
        loadComponent: () => import('@dental-ui/laboratories').then((m) => m.LaboratoriesComponent),
      },
    ],
  },
  {
    path: 'mobile-upload/patient/:patientId',
    loadComponent: () => import('@dental-ui/mobile-upload').then((m) => m.MobileUploadComponent),
  },
  {
    path: 'mobile-upload/work-order/:workOrderId',
    loadComponent: () => import('@dental-ui/mobile-upload').then((m) => m.MobileUploadComponent),
  },
];
